export default {
  data() {
    return {
      active: 0,
      staticActive:0,/* no borrar, siempre es 0 */
      /* $router: this.$router, */
    };
  },
  computed:{
    activeRouterName(){ return this.$router.currentRoute.name },
    menuLateral(){ return this.$store.getters.menuLateral },
    menuLateralIndice() { return this.$store.getters.menuLateralIndice },
    menu(){ return this.menuLateralIndice[this.id] || {}},
    menu_tabs() {
      return this.menu.tabs
        ? (this.myPermissions.length? this.menu.tabs.filter(i=> this.filter_menu_tabs(i)): this.menu.tabs.filter(i=> !i.permission))
        : [{text:this.menu.text}]
    },
    tabs() { return this.menu_tabs.filter(i=>!i.params) },
    paths() { return this.tabs ? this.tabs.map(m => m.id) : [] },
    titles(){ return this.tabs ? this.tabs.map(m => m.text) : [] },
    active_tab() { return this.active !=undefined?this.menu_tabs[this.active]:{permission:'no'}},
    active_tab_conditional() { return !!(this.active_tab||{}).params },
    can_access(){ 
      /* this.active_tab.permission no definidda, es pq no necesita permisos */
      return this.active_tab.permission === undefined || this.myPermissions.includes(this.active_tab.permission)
    },
  },
  watch:{
    myPermissions(v) { if (v) this.setActiveTab() },
    activeRouterName(v) { if (v) this.setActiveTab() },
    menu_tabs(v) { if (v) this.setActiveTab() },
  },
  created(){
    this.dev_log('created');
    /* temp hasta que el comp userinfo este actualizado - no va aca, pq este comp se puede usar de manera recursiva */ this.$store.dispatch('set', {key: 'title', val:this.menu.text});
    this.setActiveTab()
  },
  methods: {
    filter_menu_tabs(i){ return this.filter_permission(i) && this.filter_dev(i) },
    filter_permission(i) { return i.permission && this.myPermissions.length? this.myPermissions.includes(i.permission): i },
    filter_dev(i){ return i.only_dev? this.is_dev:i },
    set_active(i){this.active = i},
    setActiveTab(){
      const r = this.menu_tabs.find((f,i) => f.id === this.activeRouterName && (this.set_active(i) || true) );
      r==undefined &&(this.active=null);
      this.dev_log({r},this.activeRouterName,this.menu_tabs);

      this.dev_log('active_tab',this.active_tab);
      /* temp hasta que el comp userinfo este actualizado - no va aca, pq este comp se puede usar de manera recursiva */
      this.$store.dispatch('set', {key: 'title', val:this.menu.text});
      this.$store.dispatch('set', {key: 'subtitle', val:(this.active_tab||{}).text});
    },
    go(i){
      this.active = i;
      const tab = this.tabs[i];
      if (tab && tab.href) {
        window.location = tab.href;
        return;
      }
      this.$router.push({ name: this.paths[i]});
    },
    b(i) { if (this.active === i) return '' }
  },
};
